import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'singlePlural',
    standalone: false
})
export class SingularPluralPipe implements PipeTransform {
  transform(value: number, singular: string, plural: string): string {
    const PLURAL = 2, text = (value < PLURAL) ? singular : plural;
    return `${value} ${text}`;
  }
}
